enum PensionScheme {
  ATP = 'ATP',
  EMPLOYEE_PAID = 'EmployeePaid',
  EMPLOYER_PAID = 'EmployerPaid',
  EMPLOYEE_PAID_NET = 'EmployeePaidNet',
  EMPLOYER_PAID_NET = 'EmployerPaidNet',
}
export default PensionScheme
